import { Link } from 'react-router-dom';
export function Logo({ to = '/', small = false }: { to?: string; small?: boolean }) {
  return (
    <Link to={to} className={`block font-black leading-[.92] tracking-wide text-ink no-underline ${small ? 'text-xl' : 'text-[27px]'}`} aria-label="Math Zero — на головну">
      <span className="block">MATH</span><span className="block text-brand">ZERO</span>
      {!small && <span className="mt-1.5 block text-[11px] font-bold tracking-normal text-ink-muted">by ZNOHUB</span>}
    </Link>
  );
}
